import { UserModel } from './user';
export class DispatcherModel extends UserModel {
  isAdmin: boolean;
}
